import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Switch, Toast } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';

const api = new ApiCore();


const CSOPersonal = (props: any) => {

    const [remindReady, setRemindReady]= useState<any>(false);

    useEffect(() => {
        return () => {
        }
    }, [])

    useEffect(() => {
    }, [])

    
    return (
        <div className={styles.CSO_personal_content}>
        </div>
    )
}

export default withRouter(CSOPersonal);